/* @refresh reload */
import { lazy } from 'solid-js';
import { render } from 'solid-js/web';
import { HashRouter, Route } from '@solidjs/router';
import App from '~/App';
import { registerServiceWorker } from '~/registerServiceWorker';
import './index.css';

/**
 * Hash routing, deliberately.
 *
 * SPEC.md §11 asks for a build deployable to any static host, and read-only
 * mode is reached by a deep link (`/strategy/:id/read-only`). Path routing would
 * need a rewrite rule on every host to survive a refresh at that URL; hashes
 * need nothing, work from a subdirectory, and work offline. See DECISIONS.md.
 */

const ReadOnlyRoute = lazy(() => import('~/routes/ReadOnlyRoute'));

const root = document.getElementById('root');
if (!root) throw new Error('Root element #root is missing from index.html');

render(
  () => (
    <HashRouter>
      <Route path="/" component={App} />
      <Route path="/strategy/:strategyId/read-only" component={ReadOnlyRoute} />
    </HashRouter>
  ),
  root,
);

registerServiceWorker();
